<div class="password-cracking-settings" data-automation-id="password-cracking-settings-container">
    <div class="header-bar" data-automation-id="password-cracking-settings-header'">
        <button type="button" data-automation-id="password-cracking-settings-save-button" class="primary-button"
            (click)="saveChanges()" [disabled]="isDisabled()" *ngIf="!hasViewOnlyPermissions">Save</button>
        <button type="button" data-automation-id="password-cracking-settings-discard-changes-button"
            class="secondary-button" (click)="discardChanges()" [disabled]="isDiscardDisabled()"
            *ngIf="!hasViewOnlyPermissions">Discard Changes</button>
        <button type="button" class="help-button" data-automation-id="password-cracking-settings-help-button"
            (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <form class="content" #contentForm="ngForm" [resBusySpinner]="isBusy" [message]="isBusyMessage"
        data-automation-id="password-cracking-settings-content">
        <div class="panel-parent">
            <div class="settings-panel-header">
                <res-custom-checkbox name="foundPasswords" automationId="password-cracking-found-passwords-checkbox"
                    [(ngModel)]="foundPasswordsChecked" content="Found Passwords" isDisabled="true">
                </res-custom-checkbox>
            </div>
            <div class="modal-row found-pwds-container">
                <label [ngClass]="{'disabled': hasViewOnlyPermissions}">Password count:</label>
                <label [ngClass]="{'disabled': hasViewOnlyPermissions}"
                    class="pwd-item">{{viewModel.model.foundPasswordCount}}
                </label>
                <button type="button" data-automation-id="password-cracking-view-found-passwords-button"
                    class="secondary-button" (click)="viewFoundPasswords()" [disabled]=" hasViewOnlyPermissions">View
                    ...</button>
            </div>
            <div class="settings-panel-header top-border-spacer">
                <res-custom-checkbox name="contextDictionary"
                    automationId="password-cracking-settings-context-dictionary"
                    [(ngModel)]="viewModel.model.contextDictionary" content="Email Context"
                    [isDisabled]="hasViewOnlyPermissions" (ngModelChange)="onChange()">
                </res-custom-checkbox>
            </div>
            <div class="settings-panel-header top-border-spacer">
                <res-custom-checkbox name="goldenDictionary"
                    automationId="password-cracking-settings-known-password-list"
                    [(ngModel)]="viewModel.model.goldenDictionary" content="Known Password List"
                    [isDisabled]="hasViewOnlyPermissions" (ngModelChange)="onChange()">
                </res-custom-checkbox>
            </div>
            <div class="modal-row known-passwords-container">
                <div class="pass-row">
                    <label class="pass-cell" [ngClass]="{'disabled': hasViewOnlyPermissions}">Password count:</label>
                    <div class="pass-cell">
                        <label [ngClass]="{'disabled': hasViewOnlyPermissions}"
                            class="pwd-item">{{viewModel.model.knownPassswordCount}}
                        </label>
                        <button type="button" data-automation-id="password-cracking-view-known-passwords-button"
                            class="secondary-button" (click)="openKnownFrequentlyUsedPasswords('KNOWN_PASSWORDS')"
                            [disabled]="hasViewOnlyPermissions">View / Edit
                            ...</button>
                    </div>
                </div>
                <div class="pass-row">
                    <label class="pass-cell" [ngClass]="{'disabled': hasViewOnlyPermissions}">Last modified:</label>
                    <label [ngClass]="{'disabled': hasViewOnlyPermissions}"
                        class="pwd-item pass-cell">{{knownPassUpdateDateUser}}</label>
                </div>
            </div>
            <div class="settings-panel-header top-border">
                <res-custom-checkbox name="crackingDictionary"
                    automationId="password-cracking-settings-password-dictionary"
                    [(ngModel)]="viewModel.model.crackingDictionary" content="Frequently Used Passwords"
                    [isDisabled]="hasViewOnlyPermissions" (ngModelChange)="onChange()"></res-custom-checkbox>
            </div>
            <div class="modal-row no-wrap">
                <div class="password-cracking-first-column">
                    <div class="pass-row">
                        <label class="pass-cell" [ngClass]="{'disabled': hasViewOnlyPermissions}">Password
                            count:</label>
                        <div class="pass-cell">
                            <label [ngClass]="{'disabled': hasViewOnlyPermissions}"
                                class="pwd-item">{{viewModel.model.frequentlyUsedPasswordCount}}
                            </label>
                            <button type="button" data-automation-id="password-cracking-view-frequent-passwords-button"
                                class="secondary-button"
                                (click)="openKnownFrequentlyUsedPasswords('FREQUENTLY_USED_PASSWORDS')"
                                [disabled]="hasViewOnlyPermissions">View / Edit
                                ...</button>
                        </div>
                    </div>
                    <div class="pass-row">
                        <label class="pass-cell" [ngClass]="{'disabled': hasViewOnlyPermissions}">Last modified:</label>
                        <label [ngClass]="{'disabled': hasViewOnlyPermissions}"
                            class="pwd-item pass-cell">{{freqUsedPassUpdateDateUser}}</label>
                    </div>
                </div>
                <div class="password-cracking-second-column">
                    <div class="modal-row-column-auto">
                        <label [ngClass]="{'disabled': hasViewOnlyPermissions}">Variations to
                            Attempt:</label>
                    </div>
                    <div class="modal-row-column-auto">
                        <res-custom-checkbox name="dictionaryCapitalizeFirstLetter"
                            automationId="password-cracking-settings-capitalize-first-letter"
                            [(ngModel)]="viewModel.model.dictionaryCapitalizeFirstLetter"
                            content="Capitalize First Letter" [isDisabled]="hasViewOnlyPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="dictionaryCapitalizeAllLetters"
                            automationId="password-cracking-settings-capitalize-all-letter"
                            [(ngModel)]="viewModel.model.dictionaryCapitalizeAllLetters"
                            content="Capitalize ALL Letters" [isDisabled]="hasViewOnlyPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="dictionaryCapitalizeAnyLetters"
                            automationId="password-cracking-settings-capitalize-any-letter"
                            [(ngModel)]="viewModel.model.dictionaryCapitalizeAnyLetters" content="Capitalize Any Letter"
                            [isDisabled]="hasViewOnlyPermissions" (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="dictionaryReverseWord"
                            automationId="password-cracking-settings-word-in-reverse"
                            [(ngModel)]="viewModel.model.dictionaryReverseWord" content="Word in Reverse"
                            [isDisabled]="hasViewOnlyPermissions" (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="dictionaryUseSubstitution"
                            automationId="password-cracking-settings-common-substitutions"
                            [(ngModel)]="viewModel.model.dictionaryUseSubstitution" content="Common Substitutions"
                            [isDisabled]="hasViewOnlyPermissions" (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                    </div>
                </div>
            </div>
            <div class="settings-panel-header top-border">
                <res-custom-checkbox name="bruteForce" automationId="password-cracking-settings-brute-foce"
                    [(ngModel)]="viewModel.model.bruteForce" content="Brute Force" [isDisabled]="hasViewOnlyPermissions"
                    (ngModelChange)="onChange(); setBruteForceDefaultOptions()">
                </res-custom-checkbox>
            </div>
            <div class="modal-row  no-wrap">
                <div class="password-cracking-first-column">
                    <div class="password-cracking-length">
                        <label [ngClass]="{'disabled': hasViewOnlyPermissions}">Password Length:</label>
                        <input type="number" min="1" max="12" pattern="[0-9]*" (input)="validatePasswordLength()"
                            name="bruteMinChars" class="brute-force-input-width" [(ngModel)]="viewModel.bruteMinChars"
                            [value]="viewModel.bruteMinChars"
                            data-automation-id="password-cracking-settings-password-length-min-char-input"
                            [disabled]="hasViewOnlyPermissions" (ngModelChange)="onChange('bruteMinChars')"
                            onKeyDown="return false">
                        <label [ngClass]="{'disabled': hasViewOnlyPermissions}">to</label>
                        <input type="number" min="1" max="12" pattern="[0-9]*" (input)="validatePasswordLength()"
                            name="bruteMaxChars" class="brute-force-input-width" [(ngModel)]="viewModel.bruteMaxChars"
                            [value]="viewModel.bruteMaxChars"
                            data-automation-id="password-cracking-settings-password-length-max-char-input"
                            [disabled]="hasViewOnlyPermissions" (ngModelChange)="onChange('bruteMaxChars')"
                            onKeyDown="return false">
                        <label [ngClass]="{'disabled': hasViewOnlyPermissions}">characters</label>
                    </div>
                    <div class="modal-row" [hidden]="viewModel.bruteMinChars < viewModel.bruteMaxChars">
                        <div class="modal-row-column-auto">
                            <span class="error-popover"
                                data-automation-id="password-cracking-settings-password-length-error-label"
                                containerClass="error" container="body" [popover]="errorPopTmpl" triggers=""
                                #errorPop="bs-popover" placement="bottom"></span>
                            <ng-template #errorPopTmpl>
                                <span data-automation-id="error-popover">The minimum length is greater than the maximum
                                    length.</span>
                                <i class="fa fa-close" (click)="errorPop.hide()"></i>
                            </ng-template>
                        </div>
                    </div>
                </div>
                <div class="password-cracking-second-column">
                    <div class="modal-row-column-auto">
                        <label [ngClass]="{'disabled': hasViewOnlyPermissions}">Characters to
                            Attempt:</label>
                    </div>
                    <div class="modal-row-column-auto">
                        <res-custom-checkbox name="bruteLowerCase"
                            automationId="password-cracking-settings-brute-force-lowercase"
                            [(ngModel)]="viewModel.model.bruteLowerCase" content="Lowercase"
                            [isDisabled]="hasViewOnlyPermissions" (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="bruteUpperCase"
                            automationId="password-cracking-settings-brute-force-uppercase"
                            [(ngModel)]="viewModel.model.bruteUpperCase" content="Uppercase"
                            [isDisabled]="hasViewOnlyPermissions" (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="bruteDigits"
                            automationId="password-cracking-settings-brute-force-digits"
                            [(ngModel)]="viewModel.model.bruteDigits" content="Digits"
                            [isDisabled]="hasViewOnlyPermissions" (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="bruteSymbols"
                            automationId="password-cracking-settings-brute-force-symbols"
                            [(ngModel)]="viewModel.model.bruteSymbols" content="Symbols"
                            [isDisabled]="hasViewOnlyPermissions" (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="bruteSpace"
                            automationId="password-cracking-settings-brute-force-spaces"
                            [(ngModel)]="viewModel.model.bruteSpace" content="Spaces"
                            [isDisabled]="hasViewOnlyPermissions" (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <div class="custom-chars-container">
                            <res-custom-checkbox name="bruteCustom"
                                automationId="password-cracking-settings-brute-force-custom"
                                [(ngModel)]="viewModel.model.bruteCustom" content="Custom characters:"
                                [isDisabled]="hasViewOnlyPermissions" (ngModelChange)="onChange()">
                            </res-custom-checkbox>
                            <input type="text" name="bruteCustomChars" class="brute-force-custom-input"
                                [(ngModel)]="viewModel.model.bruteCustomChars"
                                [disabled]="!viewModel.model.bruteCustom || hasViewOnlyPermissions"
                                [value]="viewModel.model.bruteCustomChars" (ngModelChange)="onChange()"
                                data-automation-id="password-cracking-settings-brute-force-custom-chars-input">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>